import React, { Fragment } from "react";
import { createUseStyles } from "react-jss";
import { ListCell } from "../..";
import { classNames } from "../../utils/classNames";
import { DATA_COL_INDEX } from "../../utils/gridColumns";
import { canShowTooltip, getItemNodeFormatting, getItemTooltipContent, } from "./utilsV2Table";
import { InlineFeedback } from "./InlineFeedback";
import { GridColumnAlignment } from "../../types/table";
export function V2TableCell(props) {
    const { item, heading, colIndex, cellLink, drawer, dataId, dataTestId, inlineFeedback, } = props;
    const useStyles = useTableCellClasses(colIndex, !!drawer, heading.alignment ?? GridColumnAlignment.LEFT);
    const classes = useStyles();
    const itemNode = item && getItemNodeFormatting(heading, item);
    const itemTooltipContent = item &&
        canShowTooltip(itemNode, heading) &&
        getItemTooltipContent(heading, item);
    return (React.createElement(ListCell, { ariaColIndex: colIndex, role: "cell", className: classNames(classes.tableCell, classes.cellGrid, props?.className ?? ""), link: cellLink, dataId: dataId, dataTestId: dataTestId, dataHook: "table-cell", tooltip: heading.width && (props?.tooltipContent || itemTooltipContent)
            ? {
                width: heading.width,
                content: `${props?.tooltipContent || itemTooltipContent}`,
            }
            : undefined, dataField: `${heading.key}_${colIndex}` }, inlineFeedback ? (React.createElement("span", { className: classes.inlineFeedback },
        itemNode ?? props?.children,
        React.createElement(InlineFeedback, { ...inlineFeedback }))) : (React.createElement(Fragment, null, itemNode ?? props?.children))));
}
export const TABLE_CELL_STYLING = {
    minHeight: 30,
    padding: [2, 5],
    marginRight: 0,
    "& .list__cell--text": {
        display: "table-cell",
    },
    "& .form-group + .prompt, .form-group + .tooltip--wrapper .prompt, .tooltip--wrapper + .tooltip--wrapper .prompt": {
        paddingTop: 3,
    },
};
export const useTableCellClasses = (colIndex, hasDrawer, alignment) => {
    let cellGrid = {
        gridColumn: colIndex * 1,
        "-ms-grid-column": colIndex * 1,
    };
    if (hasDrawer) {
        cellGrid = {
            ...cellGrid,
            gridArea: `${DATA_COL_INDEX}${colIndex}`,
            "-ms-grid-area": `${DATA_COL_INDEX}${colIndex}`,
        };
    }
    return createUseStyles({
        inlineFeedback: {
            display: "flex",
        },
        tableCell: {
            ...TABLE_CELL_STYLING,
            textAlign: alignment,
        },
        cellGrid,
    });
};
